var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "div",
        {
          staticClass: "table-operator",
          staticStyle: { "margin-bottom": "12px" },
        },
        [
          _c("a-input-search", {
            staticStyle: { width: "240px" },
            attrs: { placeholder: "账户名称/卡号" },
            on: { search: _vm.loadList },
            model: {
              value: _vm.query.name,
              callback: function ($$v) {
                _vm.$set(_vm.query, "name", $$v)
              },
              expression: "query.name",
            },
          }),
          _c("h-select", {
            staticStyle: { width: "140px", "margin-left": "8px" },
            attrs: { placeholder: "账户类型", options: _vm.accountTypeOptions },
            on: { change: _vm.loadList },
            model: {
              value: _vm.query.accountType,
              callback: function ($$v) {
                _vm.$set(_vm.query, "accountType", $$v)
              },
              expression: "query.accountType",
            },
          }),
          _c("h-select", {
            staticStyle: { width: "120px", "margin-left": "8px" },
            attrs: { placeholder: "状态", options: _vm.enabledOptions },
            on: { change: _vm.loadList },
            model: {
              value: _vm.query.enabled,
              callback: function ($$v) {
                _vm.$set(_vm.query, "enabled", $$v)
              },
              expression: "query.enabled",
            },
          }),
          _c(
            "a-button",
            {
              staticStyle: { "margin-left": "8px" },
              attrs: { type: "primary", icon: "sync" },
              on: { click: _vm.loadList },
            },
            [_vm._v("刷新")]
          ),
          _c(
            "a-button",
            {
              staticStyle: { "margin-left": "8px" },
              attrs: { icon: "swap" },
              on: {
                click: function ($event) {
                  return _vm.doQuickTransfer(null)
                },
              },
            },
            [_vm._v("快捷转账")]
          ),
        ],
        1
      ),
      _c("a-table", {
        attrs: {
          bordered: "",
          size: "middle",
          rowKey: "id",
          columns: _vm.cols,
          dataSource: _vm.rows,
          pagination: _vm.pag,
          loading: _vm.loading,
        },
        on: {
          change: (p) => {
            _vm.pag.current = p.current
            _vm.pag.pageSize = p.pageSize
            _vm.loadList()
          },
        },
        scopedSlots: _vm._u([
          {
            key: "enabled_slot",
            fn: function (t, r) {
              return [
                _c(
                  "a-tag",
                  {
                    attrs: {
                      color: t === "1" || t === true ? "green" : "default",
                    },
                  },
                  [_vm._v(_vm._s(t === "1" || t === true ? "启用" : "停用"))]
                ),
              ]
            },
          },
          {
            key: "pay_slot",
            fn: function (t) {
              return [
                t === "1" || t === true
                  ? _c("a-tag", { attrs: { color: "blue" } }, [_vm._v("启用")])
                  : _c("span", { staticClass: "muted" }, [_vm._v("—")]),
              ]
            },
          },
          {
            key: "type_slot",
            fn: function (t) {
              return [_vm._v(_vm._s(_vm.accountTypeLabel(t)))]
            },
          },
          {
            key: "masked_slot",
            fn: function (t) {
              return [
                _c("span", { staticClass: "mono" }, [_vm._v(_vm._s(t || "—"))]),
              ]
            },
          },
          {
            key: "action",
            fn: function (t, r) {
              return [
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.openEdit(r)
                      },
                    },
                  },
                  [_vm._v("编辑扩展")]
                ),
                _c("a-divider", { attrs: { type: "vertical" } }),
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.toggleEn(r)
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        r.enabled === "1" || r.enabled === true
                          ? "停用"
                          : "启用"
                      )
                    ),
                  ]
                ),
                _c("a-divider", { attrs: { type: "vertical" } }),
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.doQuickTransfer(r)
                      },
                    },
                  },
                  [_vm._v("转账")]
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "a-drawer",
        {
          attrs: {
            title: _vm.form.id
              ? "编辑扩展 · " + (_vm.form.name || "")
              : "新增扩展",
            placement: "right",
            width: 620,
            visible: _vm.drawer,
            maskClosable: false,
          },
          on: {
            close: function ($event) {
              _vm.drawer = false
            },
          },
        },
        [
          _c(
            "a-form",
            { attrs: { layout: "vertical" } },
            [
              _c(
                "a-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "账户类型" } },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.form.account_type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "account_type", $$v)
                                },
                                expression: "form.account_type",
                              },
                            },
                            [
                              _c(
                                "a-select-option",
                                { attrs: { value: "现金" } },
                                [_vm._v("现金")]
                              ),
                              _c(
                                "a-select-option",
                                { attrs: { value: "银行卡" } },
                                [_vm._v("银行卡")]
                              ),
                              _c(
                                "a-select-option",
                                { attrs: { value: "微信" } },
                                [_vm._v("微信商户/零钱")]
                              ),
                              _c(
                                "a-select-option",
                                { attrs: { value: "支付宝" } },
                                [_vm._v("支付宝商户")]
                              ),
                              _c(
                                "a-select-option",
                                { attrs: { value: "其他" } },
                                [_vm._v("其他货币资金")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "手续费入账科目" } },
                        [
                          _c("a-select", {
                            attrs: {
                              options: _vm.subjectOpts,
                              placeholder: "默认 6603 财务费用",
                              showSearch: "",
                              optionFilterProp: "label",
                            },
                            model: {
                              value: _vm.form.fee_subject_code,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "fee_subject_code", $$v)
                              },
                              expression: "form.fee_subject_code",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "启用支付扩展" } },
                        [
                          _c("a-switch", {
                            attrs: {
                              checkedChildren: "开",
                              unCheckedChildren: "关",
                            },
                            model: {
                              value: _vm.form.pay_enabled,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "pay_enabled", $$v)
                              },
                              expression: "form.pay_enabled",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "手续费承担方" } },
                        [
                          _c(
                            "a-select",
                            {
                              model: {
                                value: _vm.form.fee_bear_side,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "fee_bear_side", $$v)
                                },
                                expression: "form.fee_bear_side",
                              },
                            },
                            [
                              _c(
                                "a-select-option",
                                { attrs: { value: "payee" } },
                                [_vm._v("收款方承担(默认)")]
                              ),
                              _c(
                                "a-select-option",
                                { attrs: { value: "payer" } },
                                [_vm._v("付款方承担")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.form.pay_enabled
                ? _c("a-divider", { attrs: { orientation: "left" } }, [
                    _vm._v("支付扩展配置（对接三方支付时填写）"),
                  ])
                : _vm._e(),
              _vm.form.pay_enabled
                ? _c(
                    "a-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "支付渠道" } },
                            [
                              _c(
                                "a-select",
                                {
                                  model: {
                                    value: _vm.form.pay_channel,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "pay_channel", $$v)
                                    },
                                    expression: "form.pay_channel",
                                  },
                                },
                                _vm._l(_vm.channels, function (c) {
                                  return _c(
                                    "a-select-option",
                                    { key: c, attrs: { value: c } },
                                    [_vm._v(_vm._s(c))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "商户号 mch_id" } },
                            [
                              _c("a-input", {
                                model: {
                                  value: _vm.form.mch_id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "mch_id", $$v)
                                  },
                                  expression: "form.mch_id",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "应用 app_id" } },
                            [
                              _c("a-input", {
                                model: {
                                  value: _vm.form.app_id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "app_id", $$v)
                                  },
                                  expression: "form.app_id",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "子商户 sub_mch_id" } },
                            [
                              _c("a-input", {
                                model: {
                                  value: _vm.form.sub_mch_id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "sub_mch_id", $$v)
                                  },
                                  expression: "form.sub_mch_id",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label:
                                  "加密密钥 api_key / 证书密码（后端 AES 落库）",
                              },
                            },
                            [
                              _c("a-password", {
                                model: {
                                  value: _vm.form.api_key_cipher,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "api_key_cipher", $$v)
                                  },
                                  expression: "form.api_key_cipher",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("a-divider", { attrs: { orientation: "left" } }, [
                _vm._v(
                  "手续费规则（ext_config.feeRules · 按8场景分别设置费率%）"
                ),
              ]),
              _c("a-table", {
                attrs: {
                  size: "small",
                  bordered: "",
                  pagination: false,
                  columns: _vm.feeCols,
                  dataSource: _vm.feeRules,
                  rowKey: "scene",
                },
                scopedSlots: _vm._u([
                  {
                    key: "rate_slot",
                    fn: function (tx, row) {
                      return [
                        _c("a-input-number", {
                          staticStyle: { width: "120px" },
                          attrs: {
                            size: "small",
                            min: 0,
                            max: 100,
                            precision: 4,
                          },
                          model: {
                            value: row.ratePct,
                            callback: function ($$v) {
                              _vm.$set(row, "ratePct", $$v)
                            },
                            expression: "row.ratePct",
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "muted",
                            staticStyle: { "margin-left": "4px" },
                          },
                          [_vm._v("%")]
                        ),
                      ]
                    },
                  },
                  {
                    key: "cap_slot",
                    fn: function (tx, row) {
                      return [
                        _c("a-input-number", {
                          staticStyle: { width: "120px" },
                          attrs: { size: "small", min: 0, precision: 2 },
                          model: {
                            value: row.capPerDeal,
                            callback: function ($$v) {
                              _vm.$set(row, "capPerDeal", $$v)
                            },
                            expression: "row.capPerDeal",
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "muted",
                            staticStyle: { "margin-left": "4px" },
                          },
                          [_vm._v("元/笔")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.drawer = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "a-button",
                {
                  staticStyle: { "margin-left": "8px" },
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.saveExt },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "快捷转账",
            visible: _vm.transferVisible,
            maskClosable: false,
            footer: null,
            width: 520,
          },
          on: {
            cancel: function ($event) {
              _vm.transferVisible = false
            },
          },
        },
        [
          _c("p", { staticClass: "muted" }, [
            _vm._v(
              "跳转到【财务管理 → 转账单】页面，创建转账单（转出账户已预填）。"
            ),
          ]),
          _c(
            "a-form",
            { attrs: { layout: "vertical" } },
            [
              _c(
                "a-form-item",
                { attrs: { label: "转出账户" } },
                [
                  _c("a-select", {
                    attrs: {
                      options: _vm.accountOpts,
                      showSearch: "",
                      optionFilterProp: "label",
                      placeholder: "请选择",
                    },
                    model: {
                      value: _vm.transferForm.outAccountId,
                      callback: function ($$v) {
                        _vm.$set(_vm.transferForm, "outAccountId", $$v)
                      },
                      expression: "transferForm.outAccountId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                { attrs: { label: "转账金额" } },
                [
                  _c("a-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { min: 0, precision: 2 },
                    model: {
                      value: _vm.transferForm.amount,
                      callback: function ($$v) {
                        _vm.$set(_vm.transferForm, "amount", $$v)
                      },
                      expression: "transferForm.amount",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-top": "12px" } },
            [
              _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.transferVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "a-button",
                {
                  staticStyle: { "margin-left": "8px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.goTransfer },
                },
                [_vm._v("创建转账单 →")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }